import React from "react";
import { DeviceChartDataResponse } from "types/deviceHooks.types";
import { useChartDataProcessor } from "./ChartDataProcessor";
import { ChartRenderer } from "./ChartRenderer";
import { ViewType } from "./TimeNavigation";

interface ChartDataViewProps {
  data: DeviceChartDataResponse | null;
  timeRangeValue: number | string;
  effectiveFromTimestamp?: number;
  effectiveToTimestamp?: number;
  viewType: ViewType;
  timeRangeLabel: string;
  zoomKey: number;
  onResetZoom: () => void;
  onViewportChange: (minTimestamp: number) => void;
}

export const ChartDataView = React.memo(function ChartDataView({
  data,
  timeRangeValue,
  effectiveFromTimestamp,
  effectiveToTimestamp,
  viewType,
  timeRangeLabel,
  zoomKey,
  onResetZoom,
  onViewportChange,
}: ChartDataViewProps) {
  const { processedData, dates, fullDates, getRange } = useChartDataProcessor({
    dataPoints: data?.dataPointHistory?.dataPoints || [],
    manifest: data?.dataPointHistory?.manifest || {
      dataPointTypes: [
        { name: "pH" },
        { name: "ORP" },
        { name: "Temperature" },
        { name: "Salinity" },
        { name: "Flow" },
        { name: "Vsdw" },
      ],
    },
    timeRangeValue,
    fromTimestamp: effectiveFromTimestamp,
    toTimestamp: effectiveToTimestamp,
  });

  const temperatureUnit =
    data?.dataPointHistory?.manifest?.dataPointTypes?.find(
      (dt) => dt.name === "Temperature",
    )?.unit || "°C";

  const vsdwUnit =
    data?.dataPointHistory?.manifest?.dataPointTypes?.find(
      (dt) => dt.name === "Vsdw",
    )?.unit || "W";

  return (
    <ChartRenderer
      processedData={processedData}
      dates={dates}
      fullDates={fullDates}
      getRange={getRange}
      temperatureUnit={temperatureUnit}
      vsdwUnit={vsdwUnit}
      viewType={viewType}
      timeRangeLabel={timeRangeLabel}
      fromTimestamp={effectiveFromTimestamp}
      toTimestamp={effectiveToTimestamp}
      zoomKey={zoomKey}
      onResetZoom={onResetZoom}
      onViewportChange={onViewportChange}
    />
  );
});
